const secrets = {
    third_party_token_set: {
        token_not_found: 'No se encontró el registro del token.',
        access_token_expired: 'El token de acceso ha expirado. Por favor, vuelve a conectar tu cuenta.',
    },
};
export default Object.freeze(secrets);
